// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.object-type-characteristic__input {
  width: calc(100% - 56px) !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/CharacteristicValueComponent.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC","sourcesContent":[".object-type-characteristic__input {\n  width: calc(100% - 56px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
